import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  debug: true,
  track_pageview: false,
  persistence: 'localStorage',
});

export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};

export default mixpanel;